<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="imgPathArr">
        <viewer v-if="row.imgPathArr">
          <img
            v-for="(x, index) in row.imgPathArr"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="700"
      ref="formModel"
    >
      <Input
        v-model="item.tno"
        placeholder="请选择"
        slot="tno"
        @on-focus="openYundan = true"
      ></Input>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>

    <Modal
      v-model="openYundan"
      fullscreen
      title="调度单号"
      footer-hide
      width="1000"
    >
      <yundanhao
        :scan="true"
        @obj="
          item.tno = $event.no;
          item.ono = $event.ono;
          openYundan = false;
        "
      ></yundanhao>
    </Modal>
  </div>
</template>
<script>
import yundanhao from "./shangmentihuoList.vue";
export default {
  components: { yundanhao },
  data() {
    return {
      isAdd: false,
      openForm: false,
      openYundan: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "创建时间",
          key: "createTime",
          sort: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        ono: "",
        tno: "",
        carNo: "",
        carId: "",
        status: 0,
        driverAccount: "",
        driver: "",
        dispatcher: "",
        dispatcherId: "",
        step: "",
        content: "",
        startTime: "",
        processTime: "",
        processResult: "",
        remark: "",
        imgPath: "",
        imgPathArr: "",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "调度单号",
          key: "tno",
          slotForm: "tno",
          required: true,
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
          readonly: true,
          required: true,
        },

        {
          title: "车牌号",
          key: "carId",
          key1: "carNo",
          required: false,
          type: "selectCar",
        },
        {
          title: "任务状态",
          key: "status", //任务状态(0-待审,1-通过,2-驳回)
          required: false,
          key2: "status2",
          type: "Select1",
          st: "taskStatus",
        },
        {
          title: "司机",
          key4: "driverAccount",
          key1: "driver",
          required: false,
          type: "selectUser",
        },
        /*  {
          title: "调度员",
          key4: "dispatcherId",
          key1: "dispatcher",
          required: false,
          val: "",
          type: "selectUser",
        }, */
        {
          title: "环节",
          key: "step",
          required: true,
          type: "Select",
          selectItems: ["提货", "送货", "报关", "仓储", "其它"],
        },
        {
          title: "事件说明",
          key: "content",
          required: "true",
          val: "",
          type: "Input",
        },
        {
          title: "开始时间",
          key: "startTime",
          key2: "startTime2",
          required: false,
          val: "",
          type: "lyyymmdd",
        },
        {
          title: "处理时间",
          key: "processTime",
          key2: "processTime2",
          required: false,
          val: "",
          type: "lyyymmdd",
        },
        {
          title: "处理结果",
          key: "processResult",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "备注信息",
          key: "remark",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "文件路径",
          key: "imgPathArr",
          slot: "imgPathArr",
          required: false,
          val: "",
          type: "lyPhoto",
        },
      ],
      searchForms: [
        {
          title: "六联单号",
          key: "sixOno",
          type: "Input",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "调度单号",
          key: "tno",
          type: "Input",
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/event/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].status = String(data[i].status);
          data[i].status2 = this.$t("taskStatus." + data[i].status);
          data[i].processTime2 = this.utils.time(
            data[i].processTime,
            "yymmddhhmm"
          );
          data[i].startTime2 = this.utils.time(data[i].startTime, "yymmddhhmm");
          data[i].imgPathArr = this.utils.isEmpty(data[i].imgPath)
            ? []
            : JSON.parse(data[i].imgPath);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();

      if (!a) {
        return;
      }
      this.item.imgPath = JSON.stringify(this.item.imgPathArr);
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/event/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/event/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-ctc/event/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);

    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/yunshushijian.vue